import {Card, Stack, Typography} from "@mui/material";
import Iconify from "../../../components/Iconify";
import {fCurrency} from "../../../utils/formatNumber";
import {DIRECTION_NAME} from "../../../constants";
import {useLocales} from "../../../locales";

export default function TripCardInfo({
                                         data,
                                         directionType,
                                         calculated,
                                         returnTrip,
                                         hovered
                                     }) {
    const {translate} = useLocales();

    return (
        <Card
            sx={{
                border: data.canceled ? "2px dashed red" : null,
                p: 2,
                width: 350,
                background: hovered ? "#e7e7e7" : "none",
                "&:hover": {
                    cursor: "pointer",
                    background: "#f0f1f2",
                },
            }}
        >
            <Stack spacing={1}>
                <InfoLine label="Broj vozila:" value={data?.numberOfVehicles} icon="mingcute:bus-line"/>
                <InfoLine label="Broj mesta:" value={data?.freeSeats < 0 ? 0 : data?.freeSeats} icon="ic:round-event-seat"/>
                <InfoLine label="Broj rezervacija:" value={data?.seatsReserved} icon="ic:round-event-seat"/>
                <InfoLine label="Prodatih karti:" value={data?.totalSold} icon="ic:round-event-seat"/>
                <InfoLine label="Broj perona:" value={data?.platformNumber || "/"} icon="mingcute:bus-line"/>

                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                    <Typography variant="h5" sx={{textAlign: "right", color: "success.main"}}>
                        {(directionType === DIRECTION_NAME[1] && data.externalSale === true && !returnTrip)
                            ? translate("chooseReturnTrip")
                            : `${fCurrency(calculated.totalAmount?.toString() || "0")} din`}
                    </Typography>
                </Stack>
            </Stack>
        </Card>
    );
}

function InfoLine({label, value, icon}) {
    return (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle2" sx={{fontWeight: 500, color: "text.disabled"}}>
                {label}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="subtitle2" sx={{fontWeight: 500, color: "text.disabled"}}>
                    {value}
                </Typography>
                {icon && <Iconify icon={icon} width={16} sx={{color: "#6DABE4"}}/>}
            </Stack>
        </Stack>
    );
}
